import { Injectable } from '@angular/core';
import {FlashController} from "./flash-controller.service";
import {GlobalService} from "../../../global.service";
import {Router} from "@angular/router";
import {TRANSACTION_TYPES} from "../constants/flash-payment-constants";

@Injectable({
  providedIn: 'root'
})
export class PaymentSupportService {

  constructor(private flashPaymentService: FlashController, private global: GlobalService, private router: Router) {
  }

  paymentRefactorProcess(typeMessage, amountPayable, selectBan, token, locationId = '',  invoiceNumber = '', quantityToAccelerate = 0) {
    this.flashPaymentService.initData();
    this.global.validateSession();
    let aomunt: string = amountPayable.toString();
    if (aomunt.substring(aomunt.length - 2, aomunt.length) === "CR") {
      this.global.notif("El monto debe ser positivo");
      return;
    }

    let amountFix = aomunt.replace("$", "");
    if (Number(amountFix) < 5) {
      this.global.notif("La cantidad a pagar debe ser mayor a $5.00 o menor de $2000.00");
      return;
    }
    this.flashPaymentService.controller.operationAmount = amountFix;
    let mount = parseFloat(String(amountPayable).replace(",", ""));
    this.flashPaymentService.controller.newPaymentRequest = {
      productId: 1,
      typeMessage,
      currentBan: selectBan,
      subscriber: atob(sessionStorage.getItem("defaultSubscriber")),
      amount: mount.toString(),
      email: atob(sessionStorage.getItem("email")),
      name: sessionStorage.getItem("name"),
      offerId: "",
      token: token,
    };
    this.flashPaymentService.controller.doPaymentRequest = {
      currentBan: selectBan,
      mount,
      token: sessionStorage.getItem("token"),
    };
    sessionStorage.setItem(
      "newPaymentRequest",
      JSON.stringify(
        this.flashPaymentService.controller.newPaymentRequest
      )
    );
    sessionStorage.setItem(
      "doPaymentRequest",
      JSON.stringify(this.flashPaymentService.controller.doPaymentRequest)
    );
    sessionStorage.setItem(
      "operationAmount",
      aomunt.substring(1, aomunt.length)
    );
    this.flashPaymentService.controller.userData = JSON.parse(
      atob(sessionStorage.getItem("getAccountDetails"))
    );
    this.flashPaymentService.controller.subscriberInfo = JSON.parse(
      atob(sessionStorage.getItem("getAccountDetails"))
    ).SubscriberInfo[0];
    this.flashPaymentService.controller.transactionType =
      typeMessage === "prepaid"
        ? TRANSACTION_TYPES[1]
        : ( typeMessage === 'payment' ? "INVOICE PAYMENTS" : "INSTALLMENT ACCELERATION");
    this.router.navigate(["flash-payment"]);
    this.flashPaymentService.controller.locationId = locationId;
    this.flashPaymentService.controller.invoiceNumber = invoiceNumber;
    this.flashPaymentService.controller.quantityToAccelerate = quantityToAccelerate;
    this.flashPaymentService.controller.accountNumber = selectBan;
    sessionStorage.setItem("flash-data", JSON.stringify(this.flashPaymentService.controller));
  }
}
